// @ts-check

import { getEndpointCallerForRoute } from "./endpoint-caller-for-route";
import { getResultsFormatterForRoute } from "./results-formatter-for-route";

/**
 * The request mediator
 * ====================
 *
 * This module is responsible to make the corresponding API calls depending on a given route.
 * It handles also the passing through of the parameters requirted for each endpoint, which will
 * be taken from the given route object parameters.
 *
 * @type { WF_RequestMediator.ModuleSignature }
 */
export const getRequestMediator = (route, api) => {
	const endpoint = getEndpointCallerForRoute(route, api);

	if (!endpoint) {
		return {
			get: () =>
				Promise.resolve({
					status: 404,
					data: {},
				}),
		};
	}

	const formatter = getResultsFormatterForRoute(route);

	return {
		get: (params, override) => endpoint(params, override),
		formatResults: (groupsArray) => formatter(groupsArray),
	};
};
